import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SignInPromptModal } from '../components/SignInPromptModal';

interface SignInModalContextType {
  showSignInModal: () => void;
  hideSignInModal: () => void;
}

const SignInModalContext = createContext<SignInModalContextType | undefined>(undefined);

export const SignInModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const showSignInModal = () => setIsOpen(true);
  const hideSignInModal = () => setIsOpen(false);

  return (
    <SignInModalContext.Provider value={{ showSignInModal, hideSignInModal }}>
      {children}
      <SignInPromptModal open={isOpen} onOpenChange={setIsOpen} />
    </SignInModalContext.Provider>
  );
};

export const useSignInModal = () => {
  const context = useContext(SignInModalContext);
  if (context === undefined) {
    throw new Error('useSignInModal must be used within a SignInModalProvider');
  }
  return context;
};
